import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DemoCTA.css';

const DemoCTA = () => {
  const navigate = useNavigate();
  
  const handleDemoClick = () => {
    // Navigate to home page
    navigate('/');
    
    // Wait for navigation to complete then scroll to demo section
    setTimeout(() => {
      const demoSection = document.getElementById('demo');
      if (demoSection) {
        demoSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };
  return (
    <section className="py-5 demo-cta-section">
      <span className="shape cross top-left">+</span>
      <span className="shape cross top-right">+</span>
      <span className="shape cross bottom-left">+</span>
      <span className="shape cross bottom-right">+</span>
      <span className="shape cross middle-left">+</span>
      <span className="shape cross middle-right">+</span>

      <div className="container">
        <div className="demo-cta-wrapper">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h2 className="demo-cta-heading">
                Create Your Own
                <br />
                <span className="highlight">AI Chatbot</span> Demo Instantly
              </h2>
            </div>
            <div className="col-lg-4 text-end">
              <div className="demo-cta-right">
                <button onClick={handleDemoClick} className="btn btn-outline-light demo-cta-btn">
                  Try it Now
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M7 17l9.2-9.2M17 17V7H7"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoCTA;
